<div
  class="limit-bar-common limit-bar-container"
  [ngClass]="{
    'primary-colors': this.color === 'primary',
    'warn-colors': this.color === 'warn',
    'error-colors': this.color === 'error',
    'success-colors': this.color === 'success'
  }"
>
  <div class="limit-bar-common limit-bar-progress" [style.width.%]="progress"></div>
</div>
